import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, ChartBar } from "@phosphor-icons/react";

export default function FormSubmissions() {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get(`/forms/${id}`),
      api.get(`/forms/${id}/submissions`),
    ]).then(([f, s]) => {
      setForm(f.data);
      setSubs(s.data);
    }).catch(e => toast.error(formatApiError(e.response?.data?.detail)))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="min-h-screen bg-[#FDFBF7]"><Navbar /><p className="p-12 font-display text-2xl">Memuat…</p></div>;

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />
      <main className="max-w-6xl mx-auto px-6 py-10">
        <Link to="/dashboard" className="inline-flex items-center gap-2 font-bold" data-testid="subs-back-link"><ArrowLeft size={18} weight="bold" /> Kembali</Link>
        <span className="nb-badge mt-6 inline-block">Respons</span>
        <h1 className="font-display font-black text-4xl tracking-tight mt-3">{form?.title}</h1>
        <p className="text-[#4A4A4A] mt-1">Total {subs.length} respons</p>

        {subs.length === 0 ? (
          <div className="nb-card mt-8 p-10 text-center">
            <ChartBar size={48} weight="bold" className="mx-auto" />
            <h3 className="font-display font-black text-2xl mt-3">Belum ada respons</h3>
            <p className="text-[#4A4A4A] mt-2">Bagikan link <span className="mono">/f/{form?.slug}</span> ke pelanggan Anda.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 gap-4 mt-6">
            {subs.map(s => (
              <div key={s.id} className="nb-card p-5" data-testid={`sub-card-${s.id}`}>
                <div className="flex justify-between items-center flex-wrap gap-2">
                  <div className="text-xs mono text-[#4A4A4A]">{new Date(s.created_at).toLocaleString("id-ID")}</div>
                  {s.routed_to?.label && (
                    <span className="nb-badge bg-[#CDB4DB]" data-testid={`sub-routed-${s.id}`}>
                      → {s.routed_to.label}
                    </span>
                  )}
                </div>
                <dl className="mt-3 space-y-2">
                  {form?.fields?.filter(f => !["heading","image","video"].includes(f.type)).map(f => (
                    <div key={f.id} className="flex flex-col">
                      <dt className="text-xs uppercase tracking-wider font-bold text-[#4A4A4A]">{f.label}</dt>
                      <dd className="font-medium">{formatAns(s.answers?.[f.id], f)}</dd>
                    </div>
                  ))}
                </dl>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

function formatAns(v, f) {
  if (v == null || v === "") return "—";
  if (Array.isArray(v)) return v.join(", ");
  if (f?.type === "rating") return `${v} / ${f.max_rating || 5} ★`;
  return String(v);
}
